// extracted by mini-css-extract-plugin
export default {"socialLinksContainer":"SocialLinks_socialLinksContainer__rgBmo"};